module.exports = __webpack_public_path__ + "static/media/location-king-007bff.8a679b54.svg";